import { RECAPTCHA_SITE_KEY } from 'global';
import { Dispatch, SetStateAction, forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { Trans, useTranslation } from 'react-i18next';

import { ISignUpForm } from 'authOld/types';
import { Field, Form } from 'coreOld/components';
import { HeaderModalOptions } from 'coreOld/constants';
import { LinkText } from 'coreOld/elements';
import { InputType, Size } from 'coreOld/enums';

import { signUpFormSchema } from './signUpSchema';
import { FooterText, FooterWrapper, ReCaptchaWrapper } from './signUpFormStyle';

interface IProps {
  isOpen: boolean;
  openAuthModal: (type: HeaderModalOptions) => void;
  onClose: () => void;
  onSubmit: () => (data: ISignUpForm) => void;
  isSubmitted: boolean;
  goBack: () => void;
  setReCaptchaToken: Dispatch<SetStateAction<string>>;
}

const SignUpFormView = forwardRef<ReCAPTCHA, IProps>(function SignUpFormView(
  { isOpen, openAuthModal, onClose, onSubmit, isSubmitted, goBack, setReCaptchaToken },
  reCaptchaRef
) {
  const { t } = useTranslation();

  const footerContent = (
    <FooterWrapper>
      <FooterText>
        <Trans
          i18nKey="messageSignIn"
          components={[
            <LinkText onClick={() => openAuthModal(HeaderModalOptions.SIGN_IN)} key="signIn" />,
          ]}
        />
      </FooterText>
      <FooterText>
        <LinkText onClick={() => openAuthModal(HeaderModalOptions.FORGOT_PASSWORD)}>
          {t('messageForgotPassword')}
        </LinkText>
      </FooterText>
    </FooterWrapper>
  );

  return (
    <Form<ISignUpForm>
      isOpen={isOpen}
      onClose={onClose}
      title={t('titleSignUp')}
      submitBtnLabel={t('buttonLabelSignUp')}
      defaultValues={{ email: '' }}
      onSubmit={onSubmit}
      disabledSubmit={
        !reCaptchaRef || typeof reCaptchaRef === 'function'
          ? false
          : !reCaptchaRef?.current?.getValue()
      }
      schema={signUpFormSchema}
      footerContent={!isSubmitted ? footerContent : null}
      hasGoBack={isSubmitted}
      goBack={goBack}
    >
      {!isSubmitted && (
        <Field
          name="email"
          label={t('labelWorkEmail')}
          type={InputType.TEXTFIELD}
          inputProps={{
            size: Size.LG,
            autoFocus: true,
          }}
        />
      )}

      {!isSubmitted && (
        <ReCaptchaWrapper>
          <ReCAPTCHA ref={reCaptchaRef} sitekey={RECAPTCHA_SITE_KEY} onChange={setReCaptchaToken} />
        </ReCaptchaWrapper>
      )}
    </Form>
  );
});

export default SignUpFormView;
